import { render, staticRenderFns } from "./AllWallet.vue?vue&type=template&id=46f0e478"
import script from "./AllWallet.vue?vue&type=script&lang=js"
export * from "./AllWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports